module.exports = __webpack_public_path__ + "img/9788954436472.018ab777.jpg";